import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { de, en, es, fr, it, nl } from './i18n';
Vue.use(VueI18n);

export let lang = '';
const path = window.location.pathname.split('/');
if(path.length > 1) {
    if(path[1].match(/^[a-z]{2}$/)) {
        lang = path[1];
    }
};
export const i18nValidation = new VueI18n({
    locale: lang,
    fallbackLocale: 'en',
    messages: {
        en, fr, nl, de, es, it
    },
    silentTranslationWarn: true
});



// WEBPACK FOOTER //
// ./src/localize.js